<template>
  <v-textarea
    outlined
    readonly
    auto-grow
    rows="1"
    append-icon="mdi-menu-down"
    dense
    hide-details
    :value="displayText"
    style="font-size: 0.85rem"
    @click="onFocus"
  ></v-textarea>
</template>
<script>
import NsrDatapointSearchDialog from "@/components/nsr/NsrDatapointSearchDialog.vue";
import { computed, inject, ref, watch } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";
import { RBU_DATASET_VALUE_TYPE } from "@/constants";

export default {
  name: "NsrDatapointInput",
  props: {
    datasetType: String,
    period: String,
    value: [String, Object],
  },
  setup(props, { root, emit }) {
    const selected_datasets = inject("NSR_CONFIG_DATASET");

    const onFocus = async function (evt) {
      setTimeout(() => {
        evt.target.blur();
        evt.preventDefault();
      }, 5);

      const datapointId = await root.$dialog.showAndWait(
        NsrDatapointSearchDialog,
        {
          showClose: false,
          persistent: true,
          datasetType: props.datasetType,
          period: props.period,
          selected_datasets: selected_datasets,
          issue_id: props.value
            ? typeof props.value === "object"
              ? props.value.issue
              : null
            : null,
          datapoint_id: props.value
            ? typeof props.value === "object"
              ? props.value.id
              : null
            : null,
        }
      );

      if (datapointId) {
        emit("input", datapointId);
      }
    };

    const datapoint = ref(null);
    const displayText = computed(() => {
      if (datapoint.value) {
        return `[${datapoint.value.dataset.alias}] - ${
          datapoint.value.descriptions
        } (${
          datapoint.value.dataset.value_type === RBU_DATASET_VALUE_TYPE.PRICE
            ? root.$parseCurrency(datapoint.value.value)
            : root.$parseNumber(datapoint.value.value)
        })`;
      } else {
        return "";
      }
    });
    const getDatapoint = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/dataset/datapoint/",
        params: {
          datapoint_id: props.value,
        },
      });

      if (response.body.success) {
        datapoint.value = response.body.point;
        emit("input", datapoint.value);
      }
    };

    watch(
      () => props.value,
      (newValue, oldValue) => {
        if (newValue) {
          if (typeof newValue === "string") {
            getDatapoint();
          } else {
            datapoint.value = newValue;
          }
        } else {
          datapoint.value = null;
        }
      },
      { immediate: true }
    );

    return {
      onFocus,
      datapoint,
      displayText,
    };
  },
};
</script>
